import { useState } from "react";
import { useAuth } from "../../utils/auth";


const PasswordChange = ({ setMessage, loginemail }) => {

    const auth = useAuth();

    const [passwordChangeStarted, setPasswordChangeStarted] = useState(false);
    const [enteredCurrentPassword, setEnteredCurrentPassword] = useState("");
    const [showPasswordIncorrect, setShowPasswordIncorrect] = useState(false);
    const [showPasswordInput, setShowPasswordInput] = useState(false);
    const [newPassword, setNewPassword] = useState({
        password: "",
        second: ""
    });
    const [passwordsNotEqualMessage, setPasswordsNotEqualMessage] = useState(false);
    const [passwordChangeSuccess, setPasswordChangeSuccess] = useState(false);
    const [passwordChangeNoSuccess, setPasswordChangeNoSuccess] = useState(false);
    const [min6characters, setmin6characters] = useState(false);

    const handleStartPasswordChange = () => {
        setPasswordChangeStarted(true);
        setMessage("");
        setShowPasswordIncorrect(false);
        setPasswordChangeSuccess(false);
        setPasswordChangeNoSuccess(false);
        setNewPassword({
            password: "",
            second: ""
        });
        setmin6characters(false);
    }

    const handleEnterCurrentPassword = (e) => {
        setEnteredCurrentPassword(e.target.value);
        setShowPasswordIncorrect(false);
    }

    const handleSubmitCurrentPassword = async() => {
        const data = {
            method: 'POST',
            path: 'auth/login',
            input: {
                loginemail,
                password: enteredCurrentPassword
            }
        }
        const result = await auth.checkPassword(data);
        if (result.success) {
            setShowPasswordInput(true);
            setPasswordChangeStarted(false);
        } else {
            setShowPasswordIncorrect(true);
        }
    }

    const handleChange = (e) => {
        setNewPassword({
            ...newPassword,
            [e.target.name]: e.target.value
        });
        setPasswordsNotEqualMessage(false);
        setmin6characters(false);
    }

    const handleSubmit = async(e) => {
        e.preventDefault();
        if (newPassword.password !== newPassword.second) {
            setPasswordsNotEqualMessage(true);
        } else if (newPassword.password.length < 6) {
            setmin6characters(true);
        } else {
            const data = {
                method: 'PATCH',
                path: `auth/${auth.user._id}/update`,
                input: {
                    loginemail,
                    password: newPassword.password
                }
            }
            const result = await auth.update(data);
            setShowPasswordInput(false);
            if (result.success) {
                setPasswordChangeSuccess(true);
            } else {
                setPasswordChangeNoSuccess(true);
            }
        }
    }


    return (
        <div className="passwordChange">
            {(!passwordChangeStarted && !showPasswordInput) &&
            <button className="startChange button" onClick={handleStartPasswordChange}>Wachtwoord wijzigen</button>
            }
            {passwordChangeStarted && 
            <div className="inputLine">
                <span>Huidige wachtwoord:</span>
                <input 
                    type="password" 
                    name="currentPassword"
                    onChange={handleEnterCurrentPassword}
                />
                <button className="button small" onClick={handleSubmitCurrentPassword}>Submit</button>
            </div>
            }
            {showPasswordIncorrect && <p>Het ingevoerde wachtwoord is onjuist. Probeer het nog eens.</p>}
            {showPasswordInput &&
            <form onSubmit={handleSubmit}>
                <div className="newPasswordInput">
                    <div className="inputLine">
                        <span>Nieuw wachtwoord:</span>
                        <input 
                            type="password"
                            name="password"
                            minLength="6"
                            onChange={handleChange}
                            value={newPassword.password}
                            required
                        />
                    </div>
                    
                    <div className="inputLine">
                        <span>Herhaal nieuw wachtwoord:</span>
                        <input 
                            type="password"
                            name="second"
                            minLength="6"
                            onChange={handleChange} 
                            value={newPassword.second}
                            required
                        />
                    </div>
                <div><button className="button small" onClick={handleSubmit}>Submit</button></div>
                {passwordsNotEqualMessage && <p>De ingevoerde wachtwoorden zijn niet gelijk</p>}
                {min6characters && <p>Ingevoerde wachtwoorden zijn niet lang genoeg (minimaal 6 characters).</p>}
            </div>


            </form>
            }
            {passwordChangeSuccess && <p>Je wachtwoord is nu gewijzigd</p>}
            {passwordChangeNoSuccess && <p>Er is iets misgegaan bij het updaten van je wachtwoord. Probeer het later nog eens.</p>}

        </div>

    );
}

export default PasswordChange;